import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { AttachFilesService } from './../../../services/attach-files.service';
import { DialogViewPictureComponent } from './attach-file-dialog-view-picture.component';
import { saveAs } from 'file-saver';
import { environment } from '../../../../environments/environment';


// Translate
import { CommonService } from './../../../services/common.service';

@Component({
  selector: 'app-attach-files-dialog',
  templateUrl: './attach-files-dialog.component.html',
  styleUrls: ['./attach-files-dialog.component.css']
})
export class AttachFilesDialogComponent implements OnInit {
  public files: Array<File> = [];
  displayedColumns = ['index', 'is_hienThi', 'filename', 'viewPicture', 'download', 'delete'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  loadListFiles: boolean;
  fileInsert: Array<string> = [];
  path: any;
  urlImg: any;
  content: any = '';
  constructor(
    private _http: HttpClient,
    private attachFiles: AttachFilesService,
    private common: CommonService,
    public dialogRef: MatDialogRef<AttachFilesDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.loadListFiles = false;
    this.onSearch();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onSearch(): void {
    this.getAttachFile();
  }
  onClick() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push(file);
      }
    };
    fileUpload.click();

  }
  onSubmit() {
    this.insertAttachFile();
  }
  cancelFile(file: File) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }
  clickMethodDelete(data: any) {
    if (confirm('You sure delete file' + data.filename)) {
      this.deleteAttachFile(data);
    }
  }
  onPress(event) {
    if (event.key == 'Enter') {
      this.onSearch()
    }
  }
  getAttachFile() {
    this.attachFiles.getAttachFilesDetail({
      tableName: this.data.tableName,
      id_data: this.data.id_data,
      content: this.content.trim()
    }, this.data.permission).subscribe(res => {
      this.loadListFiles = true;
      if (res.error) {
        this.common.messageErr(res);
      } else {
        this.dataSource = new MatTableDataSource(res.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    });
  }
  insertAttachFile() {
    this.fileInsert = [];
    const fd = new FormData();
    if (!this.data.tableName || !this.data.id_data) {
      return;
    }
    if (!this.files[0]) {
      this.common.messageErr({ error: { message: 'No file uploaded' } });
      // this.translate.get('No file uploaded').subscribe((text:string) => {console.log(text)})
      return;
    }
    fd.append('attach', this.files[0], this.data.id_data + ',' + this.data.tableName);
    for (let index = 0; index < this.files.length; index++) {
      this.fileInsert.push(this.files[index].name);
      fd.append('attach', this.files[index], this.files[index].name);
    }
    // tslint:disable-next-line: max-line-length
    this.attachFiles.insertAttachFiles({ tableName: this.data.tableName, id_data: this.data.id_data, files: this.fileInsert.join(';') }, this.data.permission)
      .subscribe(res => {
        if (res.error) {
          this.common.messageErr(res);
        } else {
          this.attachFiles.uploadAttachFiles(fd, this.data.permission)
            // tslint:disable-next-line: no-shadowed-variable
            .subscribe(res => {
              if (res.error) {
                this.common.messageErr(res);
              } else {
                this.dataSource = new MatTableDataSource(res.data);
                this.dataSource.sort = this.sort;
                this.files = [];
                this.onSearch();

              }
            });
        }
      });
  }
  deleteAttachFile(data: any) {
    this.attachFiles.deleteAttachFilesDetail({ id: data.id }, this.data.permission).subscribe(res => {
      if (res.error) {
        this.common.messageErr(res);
      } else {
        this.onSearch();
      }
    });
  }
  downloadAttachFiles(data: any) {
    this.attachFiles.downloadAttachFiles({ path: data.path }, this.data.permission).subscribe(res => {
      if (res.error) {
        this.common.messageErr(res);
      } else {
        saveAs(new File([res], data.filename));
      }
    });
  }
  showImages(data: any) {
    var fileNameArr = data.filename.split('.');
    var length_fileNameArr = fileNameArr.length;
    var formatFileName = fileNameArr[length_fileNameArr - 1];
    var fm = formatFileName.toUpperCase();
    if (fm != 'JPG' && fm != 'JPEG' && fm != 'PNG') {
      this.common.messageErr_Text('Chỉ hiển thị được ảnh!');
    } else {
      var hienThi = 1;
      if (data.is_hienThi.data[0] === 1) {
        hienThi = 0;
      }
      this.attachFiles.updateAttachFilesHienThi({ id_attachFiles: data.id_attachFiles, id: data.id, is_hienThi: hienThi }, this.data.permission)
        .subscribe(res => {
          if (res.error) {
            this.common.messageErr(res);
          } else {
            this.onSearch();
          }
        })
    }
  }
  viewImage(data: any) {
    var fileNameArr = data.filename.split('.');
    var length_fileNameArr = fileNameArr.length;
    var formatFileName = fileNameArr[length_fileNameArr - 1];
    var fm = formatFileName.toUpperCase();
    if (fm != 'JPG' && fm != 'JPEG' && fm != 'PNG') {
      this.common.messageErr_Text('Chỉ hiển thị được ảnh!');
      this.path = null
    } else {
      let url = environment.apiUrl
      this.urlImg = url + 'files/' + data.tableName + '/' + data.id_data + '/' + data.filename;
      this.goToLink(this.urlImg)
      // const dialogRef = this.dialog.open(DialogViewPictureComponent, {
      //   width: '700px',
      //   height: '80%',
      //   data: this.urlImg
      // })
      // dialogRef.afterClosed().subscribe(result => {
      // });
    }
    // console.log(this.urlImg);
    // this.urlImg = "https://www.google.com.vn/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"

  }
  goToLink(url: string) {
    window.open(url, "_blank");
  }

}
